import React from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css"; // Ensure you update the CSS file accordingly.
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as Logo } from "../../Assets/logo.svg";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAuthorized } from "../DataExtractionTool/Authentication/authenticationSlice";

export default function LandingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const { isAuthorised } = useSelector((state) => state.authentication);
  // const { isSessionValid } = useSelector((state) => state.individualSearch);
  const {  isAuthorised } = useSelector((state) => state.authentication);
  const loginState = useSelector((state) => state.authentication)
   const user_id = loginState.user.userId;

  useEffect(() => {
    if (!isAuthorised) {
      navigate("/");
    }
  }, [isAuthorised, navigate]);

  // useEffect(() => {
  //   if (!isAuthorised) {
  //     navigate("/");
  //   }
  // }, [isAuthorised]);

  // if (!isSessionValid) {
  //   dispatch(updateAuthorized(false));
  // }

  return (
    <>
      {/* AppBar for Branding */}
      <Box sx={{ flexGrow: 1 }}>
        <AppBar style={{ background: "#2E3B55" }} position="static">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              <Logo />
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>

      {/* Main Content */}
      <div className="landing-page">
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            marginBottom: 4,
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            color: "#2E3B55",
          }}
        >
          Welcome to the OneKey Reporting Tools Hub
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            marginBottom: 6,
            fontFamily: "Montserrat, sans-serif",
            color: "#555",
          }}
        >
          Click on a card below to access the corresponding tool.
        </Typography>

        
        <div className="tool-selection">
          {/* Data Extraction Tool Card */}
          <div
            className="tool-card"
            onClick={() => navigate("/data-extraction-tool/Request")}
            style={{
              background:
                "linear-gradient(135deg, #4CAF50, #81C784)",
              boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontFamily: "Montserrat, sans-serif",
                color: "#fff",
                marginBottom: 1,
              }}
            >
              Data Extraction Tool
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                color: "#F0F0F0",
              }}
            >
              Access the data extraction functionality.
            </Typography>
          </div>

          {/* AHPRA Validation Tool Card */}
          <div
            className="tool-card"
            onClick={() => navigate("/ahpra-validation-tool/dashboard")}
            style={{
              background:
                "linear-gradient(135deg, #2196F3, #64B5F6)",
              boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontFamily: "Montserrat, sans-serif",
                color: "#fff",
                marginBottom: 1,
              }}
            >
              AHPRA Validation Tool
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                color: "#F0F0F0",
              }}
            >
              Access the AHPRA data validation functionality.
            </Typography>
          </div>

          {/* Customer Matching Portal - Restricted Access */}
                  {
//                      [1, 15, 25, 38, 36, 42].includes(user_id) && (
            <div
              className="tool-card"
              onClick={() => navigate("/custome-rmatch-portal")}
              style={{
                background:
                  "linear-gradient(135deg,rgb(187, 33, 243),rgb(183, 100, 246))",
                boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Montserrat, sans-serif",
                  color: "#fff",
                  marginBottom: 1,
                }}
              >
               Customer Matching Portal
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#F0F0F0",
                }}
              >
                Access the Customer Matching Portal functionality.
              </Typography>
            </div>
          }
        </div>
      </div>
    </>
  );
}
